<template>
    <search-header title="Search Title" :results="searchResults" :query="searchQuery"/>

    <div class="site-search__loading" v-if="loading" v-cloak>
        <!-- Add some loading icon here -->
        loading...
    </div>

    <div class="site-search__error" v-else-if="errorMessage">
        {{ errorMessage }}
    </div>

    <template v-else>
        <div class="site-search__totals">Showing {{ filteredResults.length }} results</div>

        <search-results :results="displayedResults"/>

        <search-pagination
            :results="searchResults"
            :items-per-page="itemsPerPage"
            :total-pages="totalPages"
        />
    </template>
</template>

<script setup>
import {computed, onMounted, ref} from 'vue';
import {performSearch} from "../services/search";
import SearchHeader from "./SearchHeader.vue";
import SearchResults from "./SearchResults.vue";
import SearchPagination from "./SearchPagination.vue";
import {getState, useState} from "../services/stateful";

const searchQueryParam = 'q';
const searchFilterParam = 'filter';
const itemsPerPage = 10;

const totalPages = computed(() => Math.ceil(filteredResults.value.length / itemsPerPage) || 1)

const searchQuery = ref('');
const searchResults = ref([]);
const filteredResults = ref([]);
const displayedResults = ref([]);
const currentPage = useState('Search.CurrentPage', 1);
const errorMessage = ref(null);
const loading = ref(true);

onMounted(async () => {
    const search = new URLSearchParams(window.location.search);
    searchQuery.value = search.has(searchQueryParam) ? search.get(searchQueryParam) : '';
    currentPage.value = search.has('page') ? parseInt(search.get('page'), 10) : 1;

    try {
        if (searchQuery.value.length > 0) {
            searchResults.value = await performSearch(searchQuery.value);

            processResults();
        }
    } catch (error) {
        console.error(error);
        errorMessage.value = 'Something has gone wrong, please try again later.';
    } finally {
        loading.value = false;
    }
});


function processResults() {
    searchResults.value = searchResults.value
        .filter(result => result.collectionType !== 'people');

    applyFiltering.value();
}

const applyFiltering = useState('Search.ApplyFiltering', () => {
    const search = new URLSearchParams(window.location.search);
    const filter = search.has(searchFilterParam) ? search.get(searchFilterParam) : 'all';

    // Filter results based on current tab
    if (filter === 'all') {
        filteredResults.value = searchResults.value;
    } else {
        filteredResults.value = searchResults.value.filter(item => item.collectionType === filter);
    }

    // Ensure current page is within bounds
    if(currentPage.value > totalPages.value) {
        currentPage.value = totalPages.value;
    }

    // Paginate the filtered results
    const startIndex = (currentPage.value - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    displayedResults.value = filteredResults.value.slice(startIndex, endIndex);

    const generatePagination = getState('Search.Pagination.Generate');
    if(generatePagination?.value) {
        generatePagination.value();
    }
});

const triggerSearch = useState('Search.Trigger', (newQuery) => {
    const url = new URL(window.location);

    url.searchParams.set(searchQueryParam, newQuery);
    url.searchParams.delete('page');
    url.searchParams.delete(searchFilterParam);
    window.location.href = url.toString();
});
</script>
